import React from 'react'
import {
    insertNewRefTableData, submitDataWithConditions,
    visualize_exchange_noneu
} from "../../api/api";
import {Button, Modal} from 'antd'
import {updateNonEUExchangeRates} from '../ExchangeRateFuncs'
import {DefaultProps, RefTable, Validator} from "../RefTable";
import {ReloadOutlined} from "@ant-design/icons";
import {TableContext} from "@q4us-sw/q4us-ui/lib/TableV2";
import moment from "moment";

const Sync = (props)=> {
    return <React.Fragment>
        <Button style={{ width: 100 }} icon={<ReloadOutlined />} onClick={props.onSync}>Sync</Button>
    </React.Fragment>
};

export const ExchangeRatesNonEU = (props)=><RefTable {...props}/>;

ExchangeRatesNonEU.defaultProps = {
    ...DefaultProps,
    tableSchema: "exchange_rates_non_eu",
    addNewRecordSchema: "exchange_rates_non_eu_form",
    edit: true,
    fetch: async (tableName) => {
        return await visualize_exchange_noneu(tableName); },
    updateData: async (tableName, data)=>submitDataWithConditions("exchange_rates_non_eu",
        {country: tableName, ...data, updated_date: new Date().toUTCString()}, [{ key: "country", value: tableName }, { key: "from_currency", value: data.from_currency}]),
    insertData: async (tableName, data)=>insertNewRefTableData({
        country:tableName,
        ...(tableName==='CH' && { to_currency: "CHF" }),
        ...(tableName==='NO' && { to_currency: "NOK" }),
        ...(tableName==='GB' && { to_currency: "GBP" }),
        ...data
    }, "exchange_rates_non_eu", ["country"]),
    validator: {
        exchange_rate: new Validator("exchange_rate", async (value)=> {
            if(value <= 0 )
                return Promise.reject("Exchange rate cannot be zero or negative")
        }),
        to_date: new Validator("to_date", async (value) => {
            if (moment().diff(moment(value)) > 0)
                return Promise.reject("To date cannot be less than the current date")
        }),
    },
    customActionElements:[
        <TableContext.Consumer>
            {table=><Sync
                onSync = {()=> updateNonEUExchangeRates(table.props.tableName)}
            />}
        </TableContext.Consumer>
    ],
}
